module.exports = __webpack_public_path__ + "img/heizhimayanwo.2ce30ad0.png";